import { type ReactNode, type Ref, useState } from "react";
import { cn } from "ui";

import { useWorkoutEditStore } from "src/workouts/WorkoutEditContext";
import { WorkoutItemsRoot } from "src/workouts/WorkoutItems";
import { WorkoutItemsDragAndDropManagerProvider } from "src/workouts/WorkoutItemsDragAndDropManagerContext";

import {
  MinimapDragAndDropManager,
  minimapDragAndDropManagerContext,
} from "./MinimapDragAndDropManager";
import { WorkoutMinimap } from "./WorkoutMinimap";

export interface WorkoutModalBaseProps {
  header?: ReactNode;
  beforeWorkoutItems?: ReactNode;
  footer?: ReactNode;
  workoutItems?: ReactNode;
  hideWorkoutItems?: boolean;
  className?: string;
  contentClassName?: string;
  contentRef?: Ref<HTMLDivElement>;
}

export function WorkoutModalBase(props: WorkoutModalBaseProps) {
  const workoutEditStore = useWorkoutEditStore();
  const [minimapManager] = useState(() => {
    return new MinimapDragAndDropManager(workoutEditStore);
  });

  return (
    <minimapDragAndDropManagerContext.Provider value={minimapManager}>
      <WorkoutItemsDragAndDropManagerProvider>
        <div className={cn("flex min-h-0 flex-1 flex-col", props.className)}>
          {props.header}
          <div className="flex min-h-0 flex-1 flex-col lg:flex-row">
            <div
              ref={props.contentRef}
              className="min-h-0 min-w-0 flex-1 overflow-auto"
            >
              <div className={cn("p-4", props.contentClassName)}>
                {props.beforeWorkoutItems}
                {props.hideWorkoutItems
                  ? null
                  : (props.workoutItems ?? <WorkoutItemsRoot />)}
              </div>
            </div>
            {!props.hideWorkoutItems ? (
              <div className="hidden w-[250px] shrink-0 border-l bg-background lg:flex">
                <WorkoutMinimap className="w-full" />
              </div>
            ) : null}
          </div>

          {props.footer && <div className="shrink-0">{props.footer}</div>}
        </div>
      </WorkoutItemsDragAndDropManagerProvider>
    </minimapDragAndDropManagerContext.Provider>
  );
}
